import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=25fd4ac9&scoped=true"
import script from "./JobBoard.vue?vue&type=script&lang=ts"
export * from "./JobBoard.vue?vue&type=script&lang=ts"
import style0 from "./JobBoard.vue?vue&type=style&index=0&id=25fd4ac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd4ac9",
  null
  
)

export default component.exports